import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { ArrowLeft, Mail, AlertTriangle } from 'lucide-react';

export const Payment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { plan, customer } = location.state || {};

  useEffect(() => {
    if (!plan || !customer) {
      navigate('/');
      return;
    }
  }, [plan, customer, navigate]);

  return (
    <div className="min-h-screen bg-brand-50 pt-24 pb-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-xl mx-auto">
          <Button
            variant="ghost"
            onClick={() => navigate('/checkout', { state: { plan } })}
            className="mb-8 hover:bg-white/50"
          >
            <ArrowLeft className="mr-2" size={20} />
            Kembali
          </Button>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="bg-card rounded-3xl p-8 border border-border shadow-xl text-center relative overflow-hidden"
          >
            <div className="absolute top-0 left-0 w-full h-2 bg-gold-500"></div>

            <div className="mb-8 pt-4">
              <div className="w-20 h-20 bg-gold-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <AlertTriangle className="text-gold-600" size={40} />
              </div>
              <h1 className="text-2xl font-bold text-foreground mb-2">Sistem Pembayaran Sedang Maintenance</h1>
              <p className="text-foreground/70">
                Mohon maaf, sistem pembayaran otomatis sedang dalam pemeliharaan berkala.
              </p>
            </div>

            <div className="bg-brand-50 border border-brand-100 rounded-2xl p-6 mb-8 text-left">
              <h3 className="font-semibold text-brand-800 mb-2">Solusi Pembayaran Manual</h3>
              <p className="text-sm text-brand-700 mb-4">
                Silakan hubungi tim support kami untuk melanjutkan proses pembayaran secara manual atau untuk informasi lebih lanjut.
              </p>

              <a
                href="mailto:billing@iplsistem.id"
                className="flex items-center gap-3 bg-card p-4 rounded-xl border border-brand-200 hover:border-brand-400 hover:shadow-sm transition-all group"
              >
                <div className="bg-brand-100 p-2 rounded-lg group-hover:bg-brand-200 transition-colors">
                  <Mail className="text-brand-700" size={24} />
                </div>
                <div>
                  <p className="text-xs text-foreground/50 font-medium">Email Support</p>
                  <p className="text-base font-bold text-brand-700">billing@iplsistem.id</p>
                </div>
              </a>
            </div>

            <div className="border-t border-border pt-6">
              <p className="text-sm text-foreground/50">
                Order Anda untuk paket <strong>{plan?.name}</strong> telah kami catat. Tim kami akan segera menghubungi Anda.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};
